import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import "./animations.css";
import "./premium.css";
import { flushSessionDuration, initAnalytics, startSessionTimer, trackPageView } from "./analytics.js";
import { App } from "./ui/App.js";

initAnalytics();
startSessionTimer();
trackPageView("home", document.title);
window.setTimeout(() => flushSessionDuration(), 1000);

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
